export const getInitialsFromName = (name = '') => {
  const initials = name.split(' ').map((n) => n[0]);
  return initials.join('');
};

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const isValidEmail = (email) => {
  const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return regex.test(email);
};

export const draggableStyles = (provided, snapshot) => ({
  backgroundColor: snapshot.isDragging ? 'white' : 'unset',
  WebkitFilter: snapshot.isDragging
    ? 'drop-shadow(rgba(0, 0, 0, 0.2) 0px 0px 2px)'
    : 'unset',
  filter: snapshot.isDragging
    ? 'drop-shadow(rgba(0, 0, 0, 0.2) 0px 0px 2px)'
    : 'unset',
  ...provided.draggableProps.style,
});
